var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContactTitle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33387 14.6667H10.6672C13.3472 14.6667 13.8272 13.5933 13.9672 12.2867L14.4672 6.95333C14.6472 5.32667 14.1805 4 11.3339 4H4.6672C1.82054 4 1.35387 5.32667 1.53387 6.95333L2.03387 12.2867C2.17387 13.5933 2.65387 14.6667 5.33387 14.6667Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 4.00065V3.46732C5.33398 2.28732 5.33398 1.33398 7.46732 1.33398H8.53398C10.6673 1.33398 10.6673 2.28732 10.6673 3.46732V4.00065",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 8.66667V9.33333C9.33268 9.34 9.33268 9.34 9.33268 9.34667C9.33268 10.0733 9.32602 10.6667 7.99935 10.6667C6.67935 10.6667 6.66602 10.08 6.66602 9.35333V8.66667C6.66602 8 6.66602 8 7.33268 8H8.66602C9.33268 8 9.33268 8 9.33268 8.66667Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.434 7.33398C12.894 8.45398 11.134 9.12065 9.33398 9.34732",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74609 7.51367C3.24609 8.54034 4.93943 9.16034 6.66609 9.35367",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactTitle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact-title.08219e61.svg";
export { ForwardRef as ReactComponent };